import * as React from 'react';
import { ReactElement } from 'react';
import {
    Button,
    RaRecord,
    TopToolbar,
    useResourceContext,
    useRecordContext,
} from 'react-admin';
import ContentAdd from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';

const NodeEditActions = (props: NodeEditActionsProps): ReactElement => {
    const resource = useResourceContext(props);
    const record = useRecordContext(props);

    return (
        <TopToolbar>
            <Button
                component={Link as any}
                to={{
                    pathname: `/${resource}/create`,
                    state: { parentId: record?.id },
                }}
                label="ra-tree.action.add_child"
            >
                <ContentAdd />
            </Button>
        </TopToolbar>
    );
};

export interface NodeEditActionsProps {
    resource?: string;
    record?: RaRecord;
}
export default NodeEditActions;
